import { OrderDetailsResponse } from '@models/response/order';
import { createSlice } from '@reduxjs/toolkit';

type bikerState = {
  sendPrint: boolean;
  order: OrderDetailsResponse | undefined;
};

const initialState: bikerState = {
  sendPrint: false,
  order: undefined,
};

const autoPrintSlice = createSlice({
  name: 'autoPrintSlice',
  initialState,
  reducers: {
    setOrder: (state, action) => ({
      ...state,
      order: action.payload,
    }),
    setPrint: (state, action) => ({
      ...state,
      sendPrint: action.payload,
    }),
  },
});

export default autoPrintSlice;
